const SOBEYS = {
  API_KEY: process.env.NEXT_PUBLIC_API_KEY_SOBEYS,
  API_URL: process.env.NEXT_PUBLIC_URL_SOBEYS,
  BRAND: process.env.NEXT_PUBLIC_BRAND_SOBEYS,
  BANNER: process.env.NEXT_PUBLIC_BANNER_SOBEYS,
  LOCALE: process.env.NEXT_PUBLIC_LOCALE_SOBEYS,
  REGION: process.env.NEXT_PUBLIC_REGION_SOBEYS,
  GTM: process.env.NEXT_PUBLIC_GTM_SOBEYS,
  GA4: process.env.NEXT_PUBLIC_GA4_SOBEYS,
  REDIRECT_URL: process.env.NEXT_PUBLIC_REDIRECT_URL_SOBEYS,
  WHITELISTING_DOMAINS: process.env.NEXT_PUBLIC_WHITELISTING_DOMAINS_SOBEYS,
  MERCH_IDENTIFIERS: process.env.NEXT_PUBLIC_MERCH_IDENTIFIER_SOBEYS,
  SCREENSET_SUFFIX: process.env.NEXT_PUBLIC_SCREENSET_SUFFIX_SOBEYS,
  SCREENSET_PREFIX: process.env.NEXT_PUBLIC_SCREENSET_PREFIX_SOBEYS,
  CDP_URL: process.env.NEXT_PUBLIC_CDP_URL_SOBEYS,
  AEM_URL: process.env.NEXT_PUBLIC_AEM_URL_SOBEYS,
  AEM_HEADER_FOOTER: process.env.NEXT_PUBLIC_AEM_HEADER_FOOTER_SOBEYS,
  ADOBE_IO_URL: process.env.ADOBE_IO_URL_SOBEYS,
  ADOBE_IO_CLIENT_ID: process.env.ADOBE_IO_CLIENT_ID_SOBEYS,
  ADOBE_IO_CLIENT_SECRET: process.env.ADOBE_IO_CLIENT_SECRET_SOBEYS,
  ADOBE_IO_AUTH_ENABLE: process.env.ADOBE_IO_AUTH_ENABLE_SOBEYS,
  CSS_VARIABLES: "sobeysVariable",
  FAVICON: "/sobeys_favicon.ico",
};

const SAFEWAY = {
  API_KEY: process.env.NEXT_PUBLIC_API_KEY_SAFEWAY,
  API_URL: process.env.NEXT_PUBLIC_URL_SAFEWAY,
  BRAND: process.env.NEXT_PUBLIC_BRAND_SAFEWAY,
  BANNER: process.env.NEXT_PUBLIC_BANNER_SAFEWAY,
  LOCALE: process.env.NEXT_PUBLIC_LOCALE_SAFEWAY,
  REGION: process.env.NEXT_PUBLIC_REGION_SAFEWAY,
  GTM: process.env.NEXT_PUBLIC_GTM_SAFEWAY,
  GA4: process.env.NEXT_PUBLIC_GA4_SAFEWAY,
  REDIRECT_URL: process.env.NEXT_PUBLIC_REDIRECT_URL_SAFEWAY,
  WHITELISTING_DOMAINS: process.env.NEXT_PUBLIC_WHITELISTING_DOMAINS_SAFEWAY,
  MERCH_IDENTIFIERS: process.env.NEXT_PUBLIC_MERCH_IDENTIFIER_SAFEWAY,
  SCREENSET_SUFFIX: process.env.NEXT_PUBLIC_SCREENSET_SUFFIX_SAFEWAY,
  SCREENSET_PREFIX: process.env.NEXT_PUBLIC_SCREENSET_PREFIX_SAFEWAY,
  CDP_URL: process.env.NEXT_PUBLIC_CDP_URL_SAFEWAY,
  AEM_URL: process.env.NEXT_PUBLIC_AEM_URL_SAFEWAY,
  AEM_HEADER_FOOTER: process.env.NEXT_PUBLIC_AEM_HEADER_FOOTER_SAFEWAY,
  ADOBE_IO_URL: process.env.ADOBE_IO_URL_SAFEWAY,
  ADOBE_IO_CLIENT_ID: process.env.ADOBE_IO_CLIENT_ID_SAFEWAY,
  ADOBE_IO_CLIENT_SECRET: process.env.ADOBE_IO_CLIENT_SECRET_SAFEWAY,
  ADOBE_IO_AUTH_ENABLE: process.env.ADOBE_IO_AUTH_ENABLE_SAFEWAY,
  CSS_VARIABLES: "safewayVariable",
  FAVICON: "/safeway_favicon.ico",
}

export const BINDING_CONFIG = {
  "dxp-sobeys": SOBEYS,
  "sobeys": SOBEYS,
  "dxp-safeway": SAFEWAY,
  "safeway": SAFEWAY
};
